export const stringToNumber = (stringNumber?: string) => {
  if (
    !stringNumber ||
    typeof stringNumber === 'object' ||
    typeof stringNumber === 'number'
  )
    return stringNumber

  const replacedNumber = stringNumber.replaceAll(',', '.')
  const dotedNumber = !replacedNumber.includes('.')
    ? replacedNumber + '.0'
    : replacedNumber
  const number = dotedNumber.split('.')
  const numberLen = number.length
  const slicedNumber = number.slice(0, numberLen - 1)

  return +(slicedNumber.join('') + '.' + number[numberLen - 1])
}
